import React, {useState} from 'react'
import {deliveryTypes} from 'app/constant'
import OrderModal from 'app/features/orders/componentsv1/view/orderModal/OrderModal'
import OrderDeliveryMethodChange from 'app/features/orders/orderEdit/edit/components/deliveryMethod/OrderDeliveryMethodChange'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from 'setup'
import {
  setOrderDeliveryMethod,
  selectOrderDeliveryMethod,
  checkCompliance,
  selectEditOrder,
  revalidateDiscountOnDeliveryMethod,
  setIsDirtyShipping,
} from 'app/features/orders/redux/order/orderEditSlice'
import OrderModalButton from 'app/features/orders/componentsv1/view/orderModal/OrderModalButton'
import {Order} from 'app/features/orders/models/EditOrderState'

interface Props {
  onClose: () => void
  onOpenRate: () => void
}

export const DeliveryMethodDialog: React.FC<Props> = ({onClose, onOpenRate}) => {
  const dispatch = useDispatch()
  const orderDeliveryMethod = useSelector<RootState, string | any>(selectOrderDeliveryMethod)
  const [deliveryMethod, setDeliveryMethod] = useState(orderDeliveryMethod)
  const order = useSelector<RootState, Order>(selectEditOrder)

  const handleOrderDeliveryMethodChange = (deliveryMethod: string) => {
    setDeliveryMethod(deliveryMethod)
    dispatch(checkCompliance())
  }

  const handleUpdateDelivery = () => {
    dispatch(setIsDirtyShipping(true))
    dispatch(setOrderDeliveryMethod(deliveryMethod))
    dispatch(revalidateDiscountOnDeliveryMethod())
    onClose()
    return true
  }

  return (
    <OrderModal
      title='Edit Delivery Method'
      onClose={onClose}
      icon='delivery-box'
      hideFooter
      footer={
        <div className='card-footer mx-4'>
          <OrderModalButton
            onClose={onClose}
            onConfirm={handleUpdateDelivery}
            disabled={deliveryMethod === deliveryTypes.ship && !order.shippingRateId}
          />
        </div>
      }
    >
      <OrderDeliveryMethodChange
        orderDeliveryMethod={deliveryMethod}
        onHandleChange={handleOrderDeliveryMethodChange}
        onHandleEditRate={onOpenRate}
      />
    </OrderModal>
  )
}

export default DeliveryMethodDialog
